var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"theme-input",attrs:{"type":"button"},on:{"click":_vm.selectSchool}},[(!_vm.value)?[_vm._v(" "+_vm._s(_vm.$ml.get('חיפוש'))+" ")]:[_vm._v(_vm._s(_vm.value.name)+", "+_vm._s(_vm.value.city))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }